var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"shadow-sm text-center"},[_vm._v("Du hast "+_vm._s(_vm.numCompletedChallengeResultsForCampaign(_vm.id))+" von "+_vm._s(_vm.numTotalChallengesForCampaign(_vm.id))+" Herausforderungen abgeschlossen.")])}
var staticRenderFns = []

export { render, staticRenderFns }